import type { LeaderboardApi } from './leaderboard';
import type { CombatRecord, SendResult, TelemetryState } from './types';

/**
 * Façade de la télémétrie installée, accessible à la section Debug sans
 * importer le moteur : `installTelemetry` (index.ts) la pose, le panneau la lit.
 */

/** État complet exposé en Debug (le noyau `TelemetryState` y est inclus). */
export interface TelemetryDebugState extends TelemetryState {
  installId: string;
  consent: boolean;
  /** Adresse d'envoi effective (surcharge Debug comprise), `null` si aucune. */
  url: string | null;
  backend: 'indexedDB' | 'localStorage' | 'memory' | 'pending';
  sending: boolean;
  /** Schéma des enregistrements envoyés cette session : 2, ou 1 en repli (Worker pas encore à jour, A87). */
  schema?: 1 | 2;
}

export interface TelemetryApi {
  /** Instantané synchrone de l'état. */
  state(): TelemetryDebugState;
  /** « Envoyer maintenant » : mêmes conditions que tout envoi, résultat renvoyé. */
  flush(): Promise<SendResult | null>;
  /** Vide la file. */
  clear(): Promise<void>;
  /** Dernier enregistrement construit (mémoire de la session), `null` s'il n'y en a pas. */
  lastRecord(): CombatRecord | null;
  /** Efface le journal d'achats (« Effacer la sauvegarde »). */
  resetPurchases(): void;
  /** Classements globaux (A87) : lecture des tableaux et pseudonyme, jamais bloquants (A79). */
  leaderboard: LeaderboardApi;
  /** Détache tous les écouteurs et minuteurs (tests). */
  dispose(): void;
}

let current: TelemetryApi | null = null;

export function setTelemetry(api: TelemetryApi | null): void {
  current = api;
}

/** La télémétrie installée, ou `null` (avant l'installation, ou en test). */
export function getTelemetry(): TelemetryApi | null {
  return current;
}
